import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gamebet-task-wrap common-box-wrap"
}
const _hoisted_2 = { class: "bet-task-header common-box-wrap flex justify-center" }
const _hoisted_3 = { class: "box-title highlight" }
const _hoisted_4 = { class: "bet-task-wrap" }
const _hoisted_5 = { class: "bet-task-list" }
const _hoisted_6 = {
  class: "bet-task-item fixed fixed-left",
  key: "label"
}
const _hoisted_7 = { class: "bet-task-content flex flex-column justify-between" }
const _hoisted_8 = { class: "bet-target flex justify-center align-center" }
const _hoisted_9 = { class: "prize-label flex justify-center align-center" }
const _hoisted_10 = { class: "bet-task-name" }
const _hoisted_11 = { class: "bet-task-content" }
const _hoisted_12 = { class: "bet-target flex justify-center align-center" }
const _hoisted_13 = { class: "reward-image-wrap" }
const _hoisted_14 = {
  key: 0,
  class: "reward-amount"
}
const _hoisted_15 = {
  key: 1,
  class: "reward-amount"
}
const _hoisted_16 = { class: "game-list-wrap flex" }
const _hoisted_17 = ["onClick"]

import { ref, inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useHelpTool } from '@/hooks';
import { usePopupStore } from '@/store';
import { queryGameBetTask, queryGameHot, getTaskReward, getAllBetTaskReward } from '@/api';


export default {
  __name: 'index',
  setup(__props) {

const MyToast = inject('myToast')

const { t } = useI18n()

const { doEnterGame } = useHelpTool()

const popupStore = usePopupStore();

const taskList = ref([]);
const gameList = ref([]);

onMounted(() => {
  fetchGameBetTask();
  fetchGameList();
})

const fetchGameBetTask = () => {
  queryGameBetTask().then(res => {
    const { tasks } = res.data || {};
    taskList.value = tasks || [];
  })
}

const fetchGameList = () => {
  queryGameHot({
    pageSize: 6,
    current: 1,
  }).then(res => {
    gameList.value = res.data || [];
  });
}

const doClaim = (item) => {
  getTaskReward({
    activityId: item.activityId,
  }).then(res => {
    fetchGameBetTask();
    popupStore.showRewards(item.rewards);
    // 处理外部红点数量展示
    // redDotStore.getTaskReward();
  })
}

const doClaimAll = () => {
  getAllBetTaskReward().then(res => {
    const rewards = res.data || [];
    if (Array.isArray(rewards) && rewards.length > 0) {
      fetchGameBetTask();
      popupStore.showRewards(rewards);
      // 处理外部红点数量展示
      // redDotStore.getTaskReward();
    } else {
      MyToast({ type: 'fail', message: t('notify.noReward') });
    }
  })
}

return (_ctx, _cache) => {
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_loading = _resolveComponent("van-loading")
  const _directive_audio = _resolveDirective("audio")

  return (taskList.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('gameBetTask.title').toUpperCase()), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bet-task-name" }, "LVL", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('label.betAmount').toUpperCase()), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('label.prize').toUpperCase()), 1),
                _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                  class: "claim-btn highlight",
                  onClick: doClaimAll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.claimAll').toUpperCase()), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_audio]
                ])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taskList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: _normalizeClass(`bet-task-item ${index === taskList.value.length - 1 ? 'fixed fixed-right last-level' : ''}`)
              }, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, "P" + _toDisplayString(_ctx.$filter.outputAmount(item.target)), 1),
                  (Array.isArray(item.rewards) && item.rewards[0])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_van_image, {
                            class: "reward-image",
                            src: require(`@/assets/img/common/reward/type/${item.rewards[0]?.type || 'cash'}.png`)
                          }, null, 8, ["src"])
                        ]),
                        (item.rewards[0].type === 'cash')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, "P" + _toDisplayString(_ctx.$filter.outputAmount(item.rewards[0].amount)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15, "x" + _toDisplayString(item.rewards[0].amount), 1))
                      ], 64))
                    : _createCommentVNode("", true),
                  (item.status === 3)
                    ? _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                        key: 1,
                        class: "claim-btn highlight",
                        onClick: $event => (doClaim(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.claim').toUpperCase()), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_audio]
                      ])
                    : (_openBlock(), _createBlock(_component_van_button, {
                        key: 2,
                        class: _normalizeClass(`claim-btn ${index === taskList.value.length - 1 ? 'highlight' : ''}`),
                        disabled: item.status === 4
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.status === 4 ? _ctx.$t('common.claimed').toUpperCase() : _ctx.$t('common.locked').toUpperCase()), 1)
                        ]),
                        _: 2
                      }, 1032, ["class", "disabled"]))
                ])
              ], 2))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameList.value, (item) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "game-item",
              key: item.id,
              onClick: $event => (_unref(doEnterGame)({ gid: item.gid }, { title: item.name }))
            }, [
              _createVNode(_component_van_image, {
                class: "game-img",
                fit: "cover",
                src: item.icon || '-',
                "error-icon": require('@/assets/img/game/game.png')
              }, {
                loading: _withCtx(() => [
                  _createVNode(_component_van_loading, {
                    type: "spinner",
                    color: "#ADB5BF",
                    size: "24"
                  })
                ]),
                _: 2
              }, 1032, ["src", "error-icon"])
            ], 8, _hoisted_17)), [
              [_directive_audio]
            ])
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

}